import { useContext } from 'react';
import { SurveyRespondentContext } from '@/containers/SurveyResponses/Context';

export const useSelectSurveyRespondent = () => {
  const ctx = useContext(SurveyRespondentContext);
  return ctx;
};